module.exports = __webpack_public_path__ + "static/media/logo.de3f1564.svg";